import {AfterViewChecked, Component, OnInit} from '@angular/core';
import {AppService} from '../app.service';
declare let $: any;
declare let window: any;
declare let paypal: any;

@Component({
  selector: 'custom-setup-mobile',
  templateUrl: './customMobile.component.html',
  styleUrls: ['./customMobile.component.css', '../app.component.css']
})
export class CustomMobileComponent implements OnInit, AfterViewChecked {
  hasRenderedButton = false;
  customSel = 0;
  customPrice = 0;
  dayCount = 1;
  buyCustom = 1;
  maxCustom = Math.floor(this.app.currency / 10000);

  runPayment = (data, actions) => {
    let custom = {};
    if (this.customSel !== -1) {
      custom = {
        user_id: this.app.user.id,
        card_id: this.app.selectedSavedCard.id,
        type: 1,
        uses: this.customSel,
        days_purchased: 0
      };
    } else {
      custom = {
        user_id: this.app.user.id,
        card_id: this.app.selectedSavedCard.id,
        type: 1,
        uses: 0,
        days_purchased: this.dayCount
      };
    }

    let total = this.customSel === -1 ? this.dayCount : this.customPrice;
    return actions.payment.create({
      payment: {
        transactions: [
          {
            amount: {
              total: total,
              currency: 'USD'
            },
            custom: JSON.stringify(custom),
          }
        ]
      }
    });
  };
  onAuthorize = (data, actions) => {
    return actions.payment.execute().then((payment) => {
      console.log("Card upgraded: ", this.app.selectedSavedCard, " Uses: ", this.customSel);
      this.app.selectedSavedCard.custom_card = true;
      this.app.selectedSavedCard.custom_uses = this.app.selectedSavedCard.custom_uses + this.customSel;
      this.app.selectedSavedCard.paid_for = true;
      console.log("Payment: ", payment);
      this.app.broadcast({event: 'purchaseFinished'});
    })
  };

  paypalConfig = {
    env: 'production',
    client: {
      sandbox: 'AdaH7zW6JiIdhABcw6h3zIVUseemY-3bfdtS28ALi9oWcxnM6z-Vgw4dJOoc_f_Fq-e6vLdLSjR0HSb6',
      production: 'ARF4qUYRK26BGsYAHsF7BzdKv3sLgn5T-GUDScBp5JEMbVI1v3YlJU8dUuMu6FC_oUiKIOyfPJXzvKbg'
    },
    locale: 'en_US',
    style: {
      size: 'large',
      color: 'gold',
      shape: 'rect',
      label: 'pay',
      tagline: 'true'
    },
    commit: true,
    payment: this.runPayment,
    onAuthorize: this.onAuthorize,
    onCancel: this.onCancel
  };

  constructor(public app: AppService) {

  }

  ngOnInit() {
    this.app.broadcaster.subscribe((value) => {
      this.broadCastHandle(value);
    });
  }

  ngAfterViewChecked() {
    if (!this.hasRenderedButton && (this.customSel > 0 || this.customSel === -1)) {
      console.log("Should be rendering paypal button");
      paypal.Button.render(this.paypalConfig, '#paypal-buy-custom-uses');
      this.hasRenderedButton = true;
    }
  }

  backToManage() {
    this.app.broadcast({event: 'setTertiaryOne'});
  }

  buyCustomGameMoney() {
    if (Math.floor(this.buyCustom) > this.maxCustom) {
      alert("Sorry, you only have enough to purchase " + this.maxCustom + " games.");
      return;
    }
    this.app.fireWebViewEvent(4, this.app.selectedSavedCard.id, this.buyCustom, this.buyCustom * 10000);
  }

  makeCustom(count, price) {
    this.customSel = count;
    this.customPrice = price;
    console.log("Make custom: ", this.customSel, this.customPrice);
    if (count === -1) {
      this.app.fireWebViewEvent(2, this.app.selectedSavedCard.id, this.dayCount, this.dayCount);
    } else {
      this.app.fireWebViewEvent(1, this.app.selectedSavedCard.id, count, price);
    }
    // this.app.makeCardCustom(this.app.selectedSavedCard.id, count).subscribe((data) => {
    //   console.log("Card make custom: ", data);
    //   this.app.selectedSavedCard = data;
    // }, (error) => {
    //   console.log("Making card custom error: ", error);
    // });
  }

  customTimeRemains() {
    let d = new Date(this.app.selectedSavedCard.custom_until);
    console.log("D: ", d);
    let now = new Date();
    console.log("Now: ", now);
    return d > now;
    // return true;
  }

  getDateOutput() {
    let d = new Date(this.app.selectedSavedCard.custom_until);
    return "" + (d.getMonth() + 1) + "/" + d.getDate() + "/" + d.getFullYear();
  }

  checkDateLessThanFiveDays() {
    let d = new Date(this.app.selectedSavedCard.custom_until);
    d.setDate(d.getDate() - 5);
    let now = new Date();
    console.log("Now greater than d? ", now > d);
    return now > d;
  }

  expirationTime() {
    let days = this.getDayDifferenceForDates();
    let hours = this.getHourDifferenceBetween();
    let min = this.getMinuteDifferenceBetween();
    console.log("Days: ", days, " Hours: ", hours, " Minutes: ", min);
    if (days > 1) {
      return days + " Days, " + hours + " Hour(s) and " + min + " Minute(s)";
    } else if (days === 1) {
      return days + " Day, " + hours + " Hour(s) and " + min + " Minute(s)";
    } else if (hours > 1) {
      return hours + " Hours and " + min + " Minute(s)";
    } else if (hours === 1) {
      return hours + " Hour and " + min + " Minute(s)";
    } else {
      return min + ((min > 1) ? " Minutes" : "Minute");
    }
  }

  getDayDifferenceForDates() {
    let d = new Date(this.app.selectedSavedCard.custom_until);
    let now = new Date();
    let timeDiff = Math.abs(d.getTime() - now.getTime());
    let diffDays = Math.floor(timeDiff / (1000 * 3600 * 24));
    return diffDays;
  }

  getHourDifferenceBetween() {
    let d = new Date(this.app.selectedSavedCard.custom_until);
    let now = new Date();
    let timeDiff = Math.abs(d.getTime() - now.getTime());
    let diffHours = Math.floor(timeDiff / (1000 * 3600)) % 24;
    return diffHours;
  }

  getMinuteDifferenceBetween() {
    let d = new Date(this.app.selectedSavedCard.custom_until);
    let now = new Date();
    let timeDiff = Math.abs(d.getTime() - now.getTime());
    let diffMin = Math.floor(timeDiff / (1000 * 60)) % 60;
    return diffMin;
  }

  customStyle(val) {
    if (val === this.customSel) {
      return 'highlight';
    }
  }

  customCardType(type) {
    switch(type) {
      case 1:
        let d = new Date(this.app.selectedSavedCard.custom_until);
        let now = new Date();
        if (d > now) {
          return {'pointer-events': 'none', 'opacity': '0.3'};
        }
        return {};
      case 2:
        if (this.app.selectedSavedCard.custom_uses > 0) {
          return {'pointer-events': 'none', 'opacity': '0.3'};
        }
        return {};
      default:
        break;
    }
  }

  updatePaypalButton() {
    $('#paypal-buy-custom-uses').html("");
    this.hasRenderedButton = false;
  }

  onCancel(data, actions) {
    console.log("Payment canceled: ", data, actions.payment);
  }

  broadCastHandle(value: Object): void {
    switch(value['event']) {
      default:
        break;
    }
  }
}
